import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectItem, SelectItemGroup } from 'primeng/api';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { BusinessunitModel } from 'projects/core/src/lib/models/businessunit.model';
import { Subscription } from 'rxjs';

const NA_VALUE = '** N/A **';

export interface JobChangeEvent {
  candidatetype: string;
  businessunit: BusinessunitModel;
  hasjob?: boolean;
}

@Component({
  selector: 'app-orderform-jobinformation',
  templateUrl: './orderform-jobinformation.component.html',
  styleUrls: ['./orderform-jobinformation.component.scss']
})
export class PlannerOrderformJobinformationComponent implements OnInit, OnDestroy {

  @Input() form: UntypedFormGroup;
  @Input() options: { [key: string]: Array<SelectItem | SelectItemGroup> };
  @Input() texts: { [key: string]: string };

  @Output() changed = new EventEmitter<JobChangeEvent | null>();

  private subscriptions: Array<Subscription> = [];
  private hasJob = true;

  private subForm: UntypedFormGroup = this.fb.group({
    hasjob: new UntypedFormControl(this.hasJob),
    jobtitle: new UntypedFormControl('', [Validators.required]),
    recruiter: new UntypedFormControl(''),
    settings: this.fb.group({
      candidatetype: new UntypedFormControl('', [Validators.required]),
      businessunit: new UntypedFormControl('', [Validators.required]),
    })
  });

  constructor(
    private fb: UntypedFormBuilder,
    private helper: HelperService
  ) { }

  private emitChanges(): void {
    if (this.subForm.get('settings').valid) {
      this.changed.emit({
        candidatetype: this.subForm.get('settings.candidatetype').value,
        businessunit: this.subForm.get('settings.businessunit').value,
        hasjob: this.hasJob
      });
    } else {
      this.changed.emit(null);
    }
  }

  ngOnInit(): void {
    this.form.addControl('jobinformation', this.subForm);
    this.subscriptions.push(this.subForm.get('settings').valueChanges.subscribe((value: any) => {
      this.emitChanges();
    }));
    this.subscriptions.push(this.subForm.get('hasjob').valueChanges.subscribe((value: any) => {
      this.hasJob = value;
      if (value === true) {
        this.subForm.get('jobtitle').enable();
        this.subForm.get('jobtitle').setValidators([Validators.required]);
        this.subForm.get('jobtitle').updateValueAndValidity();
        if (this.subForm.get('jobtitle').value === NA_VALUE) {
          this.subForm.get('jobtitle').setValue('');
        }
      } else {
        this.subForm.get('jobtitle').disable();
        this.subForm.get('jobtitle').clearValidators();
        this.subForm.get('jobtitle').setValue(NA_VALUE);
      }
      this.emitChanges();
    }));
    if (this.options.candidatetype?.length > 0) {
      this.subForm.get('settings.candidatetype').setValue(this.options.candidatetype[0].value);
    }
  }

  ngOnDestroy(): void {
    this.helper.unsetSubscriptions(this.subscriptions);
  }

  public getPayload(): any {
    return {
      jobtitle: (this.subForm.get('hasjob').value === true) ? this.subForm.get('jobtitle').value : null,
      recruiter: this.subForm.get('recruiter').value,
      candidatetype: this.subForm.get('settings.candidatetype').value,
      businessunit: this.subForm.get('settings.businessunit').value?.id,
    };
  }

}
